import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {editCurrentUser, editUser, loadCurrentUser, loadUsers} from "../user/usersAction";
import styled from "styled-components";
import {ROLE_ADMIN, ROLE_AMBASSADOR, ROLE_CODIR, ROLE_ENJOY, ROLE_USER} from "../../permissions/roleTypes";
import accountSVG from "../../images/account.svg";
import {ErrorMessage, Formik} from "formik";
import InputImage from "../inputs/InputImage";
import {DisplayForAmbassador} from "../../permissions/DisplayAccordingToRole";
import {GreenButton} from "../buttons/ButtonStyles";
import * as Yup from "yup";
import {useLocation} from "react-router-dom";
import {MY_ACCOUNT_ROUTE} from "../../routes/routesName";
import useImageChange from "../../custom-hooks/useImageChange";
import {FormFormik, InputTextFormik} from "../inputs/InputStyle";
import TagInput from "../inputs/TagInput";
import useSortItems from "../../custom-hooks/useSortItems";
import useTags from "../../custom-hooks/useTags";

const EditUserModal = ({setModalIsOpen, isCurrentUser}) => {
    const currentUser = useSelector(state => state.currentUser)
    const location = useLocation()

    const {
        id: userId,
        phone: userPhone,
        email: userEmail,
        tags: userTags,
        firstName: userFirstName,
        lastName: userLastName,
        roles: userRoles,
        photo: userImage
    } = useSelector(state => state.oneUser)


    const {selectedTags, setSelectedTags} = useTags([], isCurrentUser ? currentUser.tags : userTags)

    const dispatch = useDispatch()
    const {status} = useSelector(state => state.oneUser)


    const userImg = isCurrentUser ? currentUser.photo : userImage
    const userSelectedId = isCurrentUser ? currentUser.id : userId
    const {returnRemovedItems, returnAddedItems} = useSortItems()

    const {imageSize, lengthError, image, onImageChange} = useImageChange(userSelectedId, userImg, accountSVG, "users")

    const returnValueForSelect = () => {
        if (isCurrentUser) {
            if (currentUser.roles.includes(ROLE_ENJOY)) {
                return "enjoy"
            }
            if (currentUser.roles.includes(ROLE_ADMIN)) {
                return "admin"
            }
            if (currentUser.roles.includes(ROLE_CODIR)) {
                return "codir"
            }
            if (currentUser.roles.includes(ROLE_AMBASSADOR)) {
                return "ambassador"
            }
            if (currentUser.roles.includes(ROLE_USER)) {
                return "member"
            }
        } else {
            if (userRoles.includes(ROLE_ENJOY)) {
                return "enjoy"
            }
            if (userRoles.includes(ROLE_ADMIN)) {
                return "admin"
            }
            if (userRoles.includes(ROLE_CODIR)) {
                return "codir"
            }
            if (userRoles.includes(ROLE_AMBASSADOR)) {
                return "ambassador"
            }
            if (userRoles.includes(ROLE_USER)) {
                return "member"
            }
        }
    }
    const [selectedRole, setSelectedRole] = useState(returnValueForSelect())

    const imageChange = async (e) => {
        await onImageChange(e)
        if (isCurrentUser) {
            dispatch(loadCurrentUser(currentUser.id))
        } else {
            dispatch(loadUsers())
        }
    }

    const handleChange = (e) => {
        setSelectedRole(e.target.value)
    }


    const handleSubmit = async (data) => {
        data.role = selectedRole
        let keyName = "tagId"
        let initialTags = isCurrentUser ? currentUser.tags : userTags
        let removedTags = returnRemovedItems(selectedTags, initialTags, keyName)
        let addedTags = returnAddedItems(selectedTags, initialTags, keyName)
        if (removedTags) {
            data.removeTags = removedTags
        }
        if (addedTags) {
            data.tags = addedTags
        }
        if (isCurrentUser) {
            await dispatch(editCurrentUser(currentUser.id, data))
        } else {
            await dispatch(editUser(userId, data))
            dispatch(loadUsers())
        }
        setModalIsOpen(false)
    }

    const displayOrderedRolesAccordingToRoleUser = () => {
        let roleOptionArray = []
        let mostImportantRole = userRoles[0]
        let label
        const roleArray = [ROLE_CODIR, ROLE_AMBASSADOR, ROLE_USER]


        // Take the most important role of the user and put it on the top of the list : the first thing the user see is the list
        roleArray.forEach((role) => {
                if (role === mostImportantRole) {
                    let index = roleArray.indexOf(mostImportantRole)
                    roleArray.splice(index, 1)
                    roleArray.unshift(mostImportantRole)
                }
            }
        )
        // Translate every role from the back to a french version
        roleArray.forEach((role) => {
            if (role === ROLE_CODIR) {
                label = "Codir"
            }
            if (role === ROLE_AMBASSADOR) {
                label = "Ambassadeur"
            }
            if (role === ROLE_USER) {
                label = "Collaborateur"
            }
            roleOptionArray.push({value: role, label: label})
        })
        return roleOptionArray
    }

    const returnInfoValue = (currentUserValue, randomUserValue) => {
        if (isCurrentUser) {
            return currentUserValue
        } else {
            if (randomUserValue) {
                return randomUserValue
            } else {
                return ""
            }
        }
    }
    const SignupSchema = Yup.object().shape({
        firstName: Yup.string()
            .max(50, 'Le prénom est trop long')
            .required('Le champs est requis'),
        lastName: Yup.string()
            .max(50, 'Le nom est trop long')
            .required('Le champs est requis'),
        email: Yup.string()
            .email('Email invalide')
            .required('Le champs est requis'),
        phone: Yup.string()
        // .matches(phoneRegExp, 'Le numéro de téléphone est invalide'),
    });

    return (

        <Container>
            <Formik
                initialValues={{
                    firstName: returnInfoValue(currentUser.firstName, userFirstName),
                    lastName: returnInfoValue(currentUser.lastName, userLastName),
                    email: returnInfoValue(currentUser.email, userEmail),
                    phone: returnInfoValue(currentUser.phone, userPhone),
                }}
                validationSchema={SignupSchema}
                onSubmit={handleSubmit}
            >
                {() => (
                    <Form>
                        <div className={"flex-col gap-1 w-100"}>
                            {location.pathname !== MY_ACCOUNT_ROUTE &&
                            <InputImage
                                image={image}
                                lengthError={lengthError}
                                onChange={imageChange}
                                name={'utilisateur'}
                            />
                            }

                            {lengthError &&
                            <p className={"error-text"}> La taille de votre image est trop importante, veuillez
                                choisir une taille inférieure à 1Mo ({imageSize})</p>
                            }
                            <FullNameSection className={"flex-row "}>
                                <div>
                                    <InputTextFormik
                                        name="firstName"
                                        type={"text"}
                                        placeholder={'Prénom'}
                                    />
                                    <ErrorMessage
                                        name="firstName"
                                        render={msg => <div><p className="error-text"> {msg} </p></div>}
                                    />
                                </div>
                                <div>
                                    <InputTextFormik
                                        name="lastName"
                                        type={"text"}
                                        placeholder={'Nom de famille'}

                                    />
                                    <ErrorMessage
                                        name="lastName"
                                        render={msg => <div><p className="error-text"> {msg} </p></div>}

                                    />
                                </div>

                            </FullNameSection>

                            <InputTextFormik
                                name="email"
                                type="email"
                                placeholder={'Email'}
                            />
                            <ErrorMessage
                                name="email"
                                render={msg => <div><p className="error-text"> {msg} </p></div>}/>
                            {(status !== 0 && status.toString().startsWith("5")) &&
                            <p className={'error-text'}> Il semblerait que cet email soit déjà pris </p>}

                            <InputTextFormik
                                name="phone"
                                type="tel"
                                placeholder={'Téléphone'}
                            />
                            <ErrorMessage
                                name="phone"
                                render={msg => <div><p className="error-text"> {msg} </p></div>}
                            />

                            <DisplayForAmbassador
                                component={
                                    <InputTextFormik
                                        as="select"
                                        name="roles"
                                        onChange={(e) => handleChange(e)}
                                    >
                                        {displayOrderedRolesAccordingToRoleUser().map(role => (
                                            <option value={role.value}> {role.label} </option>
                                        ))}
                                    </InputTextFormik>
                                }
                            />
                            <TagInput
                                setSelectedTags={setSelectedTags}
                                selectedTags={selectedTags}
                                actionName={'users'}
                            />
                        </div>
                        <Button type="submit">
                            <h6> Modifier </h6>
                        </Button>
                    </Form>
                )}
            </Formik>
        </Container>

    )
}

const Form = styled(FormFormik)`
  flex-grow: 1;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
`

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  @media (min-width: 768px) {
    width: 90%;
  }
`
const Button = styled(GreenButton)`
  width: 5rem;
  align-self: center;
`
const FullNameSection = styled.div`
  justify-content: stretch;
  gap: 1em;

  div {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

  }
`
export default EditUserModal